import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconCopy } from "../../Experimental__Icon/icons/Experimental__IconCopy";
import { Icon } from "../";
export function IconLink(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconCopy, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M13.31 10.87a3.8 3.8 0 010 5.36L9.75 19.8a3.94 3.94 0 01-5.55 0h0a3.94 3.94 0 010-5.55L7 11.41\" fill=\"none\" stroke=\"#181818\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M10.69 13.13a3.8 3.8 0 010-5.36l3.56-3.57a3.94 3.94 0 015.55 0h0a3.94 3.94 0 010 5.55L17 12.58\" fill=\"none\" stroke=\"#181818\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
    }
  }));
}
export default IconLink;